//加载公共引入
import '@/common/syscom/main-common';
//加载自身
import Vue from 'vue';
import App from '@/pub/App';
import router from './router';
import store from '@/store';
import ZJChart from '@/common/zj-chart';
import * as options from "@/common/js/options";
import messageHubProxy from '@/common/js/messageHubProxy';
import '@/assets/css/zxxGlobal.css';
import dataV from '@jiaminghi/data-view'

Vue.use(messageHubProxy)
Vue.use(ZJChart);
Vue.use(dataV)


//引入全局变量
Vue.prototype.Global = {
    baseUrl: baseUrl, //当前url
    options: options, //全局下拉框选项
    fssUrl: fssUrl,
    fssUid: fssUid,
    fssName: fssName,//文件储存名称
    wxUrl: wxUrl
}

/* eslint-disable no-new */
vm = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});